var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ShapeToolPopover',{attrs:{"no-shape-length":_vm.noShapeLength,"shapes":_vm.shapes,"selected-shapes":_vm.selectedShapes},on:{"onSelectShape":_vm.onSelectShape,"onClose":_vm.onClose,"applyChosenShapes":_vm.applyChosenShapes}})}
var staticRenderFns = []

export { render, staticRenderFns }